<template>
  <nav>
    <v-toolbar color="primary" dark app class="z-index-6">
      <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
      <v-toolbar-title>
        <v-btn large flat router to="/">
          <v-icon left>home</v-icon>
          Syclus 2.0
        </v-btn>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <!-- <v-toolbar-items class="hidden-sm-and-down">
        <v-btn flat router to="/projetos">Projetos</v-btn>
        <v-btn flat router to="/atividades">Atividades</v-btn>
        <v-btn flat router to="/ocorrencias">Ocorrências</v-btn>
      </v-toolbar-items>-->
      <IconNotificacao />
    </v-toolbar>
    <v-navigation-drawer v-model="drawer" app temporary>
      <v-list class="pa-1" v-if="user">
        <v-list-tile avatar>
          <v-list-tile-avatar color="primary">
            <span class="white--text headline">{{ user.Descricao[0] }}</span>
          </v-list-tile-avatar>

          <v-list-tile-content>
            <v-list-tile-title>{{ user.Descricao }}</v-list-tile-title>
            <router-link :to="{ name: 'perfil', params: { id: user.IdUsuario }}">Perfil</router-link>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>

      <v-list>
        <v-divider></v-divider>
        <!-- Sistema -->
        <v-list-group prepend-icon="account_circle" :value="false" v-if="isAdmin">
          <template v-slot:activator>
            <v-list-tile>
              <v-list-tile-title>Sistema</v-list-tile-title>
            </v-list-tile>
          </template>
          <v-list-tile v-for="(sistema, index) in sistemas" :key="index" :to="sistema.route">
            <v-list-tile-title class="pl-5 ml-2">{{ sistema.title }}</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>{{ sistema.icon }}</v-icon>
            </v-list-tile-action>
          </v-list-tile>
        </v-list-group>
        <!-- Comuns -->
        <v-list-group prepend-icon="account_circle" :value="false">
          <template v-slot:activator>
            <v-list-tile>
              <v-list-tile-title>Comuns</v-list-tile-title>
            </v-list-tile>
          </template>
          <v-list-tile v-for="(comum, index) in comuns" :key="index" :to="comum.route">
            <v-list-tile-title class="pl-5 ml-2">{{ comum.title }}</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>{{ comum.icon }}</v-icon>
            </v-list-tile-action>
          </v-list-tile>
        </v-list-group>

        <!-- Atividades -->
        <v-list-group prepend-icon="list_alt" :value="false">
          <template v-slot:activator>
            <v-list-tile>
              <v-list-tile-title>Atividades</v-list-tile-title>
            </v-list-tile>
          </template>
          <v-list-tile v-for="(atividade, index) in atividades" :key="index" :to="atividade.route">
            <v-list-tile-title class="pl-5 ml-2">{{ atividade.title }}</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>{{ atividade.icon }}</v-icon>
            </v-list-tile-action>
          </v-list-tile>
        </v-list-group>

        <!-- Projetos -->
        <v-list-group prepend-icon="list_alt" :value="false">
          <template v-slot:activator>
            <v-list-tile>
              <v-list-tile-title>Projetos</v-list-tile-title>
            </v-list-tile>
          </template>
          <v-list-tile v-for="(projeto, index) in projetos" :key="index" :to="projeto.route">
            <v-list-tile-title class="pl-5 ml-2">{{ projeto.title }}</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>{{ projeto.icon }}</v-icon>
            </v-list-tile-action>
          </v-list-tile>
        </v-list-group>

        <!-- Ocorrências -->
        <v-list-group prepend-icon="list_alt" :value="false">
          <template v-slot:activator>
            <v-list-tile>
              <v-list-tile-title>Ocorrências</v-list-tile-title>
            </v-list-tile>
          </template>
          <v-list-tile v-for="(ocorrencia, index) in ocorrencias" :key="index" :to="ocorrencia.route">
            <v-list-tile-title class="pl-5 ml-2">{{ ocorrencia.title }}</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>{{ ocorrencia.icon }}</v-icon>
            </v-list-tile-action>
          </v-list-tile>
        </v-list-group>

        <!-- Configurações -->
        <v-list-group prepend-icon="settings" :value="false" v-if="isAdmin">
          <template v-slot:activator>
            <v-list-tile>
              <v-list-tile-title>Configurações</v-list-tile-title>
            </v-list-tile>
          </template>
          <v-list-tile v-for="(config, index) in computedRoutes" :key="index" :to="config.route">
            <v-list-tile-title class="pl-5 ml-2">{{ config.title }}</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>{{ config.icon }}</v-icon>
            </v-list-tile-action>
          </v-list-tile>
        </v-list-group>

        <v-list-tile v-for="item in items" :key="item.title" :to="item.route">
          <v-list-tile-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-tile-action>

          <v-list-tile-content>
            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-divider></v-divider>
        <v-list-tile @click="logout">
          <v-list-tile-action>
            <v-icon>exit_to_app</v-icon>
          </v-list-tile-action>

          <v-list-tile-content>
            <v-list-tile-title>Sair</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
  </nav>
</template>

<script>
import { mapGetters } from "vuex";
import IconNotificacao from '@/components/notificacao/IconNotificacao';

export default {
  name: "Navbar",
  components: {
    IconNotificacao
  },
  data() {
    return {
      drawer: null,
      sistemas: [
        { title: "Usuários", route: "/usuarios", icon: "group_add" },
      ],
      comuns: [
        { title: "Clientes", route: "/clientes", icon: "group_add" },
        { title: "Colaboradores", route: "/colaboradores", icon: "person" },
        { title: "Equipes", route: "/equipes", icon: "group_add" },
        { title: "Motivos", route: "/motivos", icon: "folder" },
        { title: "Tipos colaborador", route: "/tiposcolaborador", icon: "folder" },
        { title: "Situações", route: "/situacoes", icon: "folder" },
        { title: "Tipos Situação", route: "/tipossituacao", icon: "folder" },
        { title: "Tags", route: "/tags", icon: "folder" },
        { title: "Prioridades", route: "/prioridades", icon: "folder" },
        { title: "Bairros", route: "/bairros", icon: "folder" },
        { title: "Workflows", route: "/workflows", icon: "folder" },
      ],
      atividades: [
        { title: "Helpdesk", route: "/helpdesk", icon: "dashboard" },
        { title: "Atividades", route: "/atividades", icon: "assignment" },
        { title: "Modelos Atividade", route: "/modelosatividade", icon: "folder" },
        { title: "Tipos Atividade", route: "/tiposatividade", icon: "folder" },
      ],
      ocorrencias: [
        { title: "Ocorrências", route: "/atividadesocorrencias", icon: "comment" },
        { title: "Modelos Ocorrência", route: "/modelosocorrencia", icon: "folder" },
        { title: "Tipos Ocorrência", route: "/tiposocorrencia", icon: "folder" },
      ],
      projetos: [
        { title: "Projetos", route: "/projetos", icon: "assignment" },
        { title: "Tipos Projeto", route: "/tiposprojeto", icon: "folder" },
      ],
      configs: [
        { title: "Sqls", route: "/sqls", icon: "code", verify: true },
        { title: "Layouts Sql", route: "/layoutssql", icon: "tune", verify: true },
      ],
      items: [
        { title: "Notificações", route: "/notificacoes", icon: "notifications" },
      ]
    };
  },
  methods: {
    logout() {
      if (confirm("Deseja realmente sair do sistema?")) {
        this.$store.dispatch('logout');
        this.$router.replace({ name: "login" });
      }
    }
  },
  computed: {
    ...mapGetters(["user", "isAdmin"]),
    computedRoutes() {
      if (this.isAdmin) {
        return this.configs;
      } else {
        return this.configs.filter(route => route && !route.verify);
      }
    },
  }
};
</script>

<style scoped>
.z-index-6 {
  z-index: 6;
}
</style>
